import React, { useContext, useState, useEffect } from "react";
import { TranslatorContext } from "../../../context/Translator";
import { Link, useParams } from "react-router-dom";
import PageLayout from "../../../layouts/PageLayout";

import { Form,     FloatingLabel,
Row, Col, Dropdown, Card, Carousel, CardHeader } from "react-bootstrap";

import specifics from "../../../assets/data/specifics.json";

import axios from "axios";
import moment from "moment";
export default function PersonReportPage() {
    const AuthToken = localStorage.getItem("AuthUser");
    const { fsf_num } = useParams();
    const [family, SetFamily] = useState({});
    const { t } = useContext(TranslatorContext)

    const [formState, setFormState] = useState({
        identifier_id: "",
        beneficiary_name: "",
        gender_id: "",
        slavery_years: "",
        mob: "",
        cnic: "",
        cnic_expire_date: "",
        dob: "",
        reason: "",
        marital_status_id: "",
        slavery_reason_id: "",
        occupation_id: "",
        assessment_date: "", // fixed spelling
        faith_id: "",
        baptised: "",
        city_id: "",
        verification_date: "",
        rescue_date: "",
        present_address: "",
        number_of_work_dependents: "",
        permanent_address: "",
        avatar: { file: null, preview: null, imgsrc: "" },
        cnic_f_img: { file: null, preview: null, imgsrc: "" },
        cnic_b_img: { file: null, preview: null, imgsrc: "" },
        union_council: "",
        // church deatails
        church_name: "",
        pastor_name: "",
        pastor_cell_number: "",
        is_visited_by_pastor: "",
        frequent: "",
        flagged: "",
        live_by_choice: "",
        living_address: null,
        distance_to_home: null,

        /// Family details
        is_parent_dependent: false,
        father_name: "",
        father_cnic: "",
        father_dob: "",
        father_slavry_years: "",
        father_is_dead: false,
        mother_name: "",
        mother_cnic: "",
        mother_dob: "",
        mother_slavry_years: "",
        mother_is_dead: false,
        spouse_name: "",
        spouse_cnic: "",
        spouse_dob: "",
        spouse_slavry_year: "",
        spouse_is_dead: false,
        relationship_id: "",
        kin_list: [],
        worker_list: [],

        /// Family story
        family_story: "",
        extra_comments: "",
        prayer_request: "",
        family_story_audio: "",

        /// Childrens
        no_child: false,
        child: [],

        /// Loan
        brick_kiln_id: "",
        loan_type_id: "",
        est_loan_amount: "",
        loan_amount: "",
        medical_amount: "",
        food_ration: "",
        meal_amount: "",
        khatta_amount: "",
        utility_amount: "",
        rent_amount: "",
        other: "",
        affidavit_amount: "",
        total_pkr: 0,
        unpaid_loan_file: { file: null, preview: null, imgsrc: "" },
        khatta_unpaid_file: { file: null, preview: null, imgsrc: "" },

        number_of_dependents: "",
        live_on_brick_kiln: "",

        /// Acknowledgement
        identifier: {
            id: "",
            user_id: "",
            city_id: "",
            name: "",
            phone: "",
            cnic: "",
            org: "",
            signature: "",
            created_at: "",
            updated_at: "",
        },
        mobilizer: "",
        mobilizer_id: "",
        f_number: "",
        prayer_request: "",
        is_allow_to_meet_relatives: "",
        working_hours: "",
        working_years_on_brick_kiln: "",
        first_loan_amount: "",
        loan_year: "",

        // Feasibility Assesment

        want_to_leave_work: "",
        why: "",
        plans_after_leaving_work: "",
        willing_to_learn_new_skills: "",
        new_skill_or_job: "",
        willing_to_educate_children: "",
        willing_to_pay_in_installments: "",
    });
    const handleChange = (e) => {

        console.log(e.target.name, e.target.value);
        setFormState({
            ...formState,
            [e.target.name]: e.target.value,
        });
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
                const response = await axios.get(
                    process.env.REACT_APP_API_URL + "/family-report/" + fsf_num
                );
                SetFamily(response.data.person);

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

    const calculateAge = (dob) => {
        console.log(dob)
        if (!dob) return null; // Return null if no date is provided
        const age = moment().diff(moment(dob, "YYYY-MM-DD"), "years");
        return age;
    };
    const fields = [
        'release_img',
        'new_home_img',
        'affidavit',
        'family_working_img',
        'family_check_img',
        'relocation_img',
        'img_1',
        'img_2',
        'img_3',
        'img_4',
        'img_5',
        'img_6',
    ]
    return (
        <PageLayout>
            <div className="mc-card mb-4">
                <div className='mc-breadcrumb'>
                    <h3 className="mc-breadcrumb-title">{"Family Report"}</h3>
                    <ul className="mc-breadcrumb-list">
                        <li className="mc-breadcrumb-item"><Link to='/' className="mc-breadcrumb-link">{t('home')}</Link></li>

                        <li className="mc-breadcrumb-item">{"Family Report"}</li>
                    </ul>
                </div>
            </div>
           

          <Row>
    
<Row>
  {/* DISABILITY ASSESSMENT */}
  <h5>DISABILITY ASSESSMENT</h5>
  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>Trouble seeing, even with glasses?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

<Col md={6}>
  <div className="mc-card p-sm-4">
    <h6 className="" >
      Question: <span>Difficulty hearing, even with a hearing aid?</span>
    </h6>
      <p>aasd{family?.family_story}</p>
  </div>
</Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>Difficulty walking or climbing steps?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>Difficulty remembering or concentrating?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>Difficulty with self-care, like washing or dressing?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  {/* SKILL ASSESSMENT */}
  <h5>SKILL ASSESSMENT</h5>
  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>What technical skills do you have?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>Do you possess any creative skills?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>What skill would you be willing to learn if given a chance?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  {/* EDUCATION ASSESSMENT */}
  <h5>EDUCATION ASSESSMENT</h5>
  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>Education (if any)?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>What is your highest educational qualification?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>Are you currently enrolled in any educational program?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  {/* ABUSE ASSESSMENT */}
    <h5>ABUSE ASSESSMENT</h5>
  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>Have you been beaten by a brick kiln owner or munshi?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>If yes: Who beat you?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>What was the reason?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>When did it happen last?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>How many times in the last year?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>Did you suffer any injuries?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>Verbally abused by a brick kiln owner or munshi?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>If yes: Who?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>When did it happen last?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>What were the main reasons?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>How many times in the last year?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>Punished by a brick kiln owner or munshi?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>If yes: Who punished you?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>What was the punishment?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>When did it happen last?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>What were the main reasons?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>How many times in the last year?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>Forced into sexual acts by a brick kiln owner or munshi?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4">
            Question: <span>If yes: Who?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

  <Col md={6}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4 wrap-word">
            Question: <span>When did it happen last?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>
          </div>
        </Col>
      </Row>
    </div>
  </Col>

    <Col md={12}>
    <div className="mc-card p-sm-4">
      <Row>
        <Col md={12} className="mt-1">
          <h6 className=" mb-4 wrap-word">
            Question: <span>Abused?</span>
          </h6>
          <div className="mc-product-view-descrip">
            <p>{family?.family_story}</p>

           
          </div>
        </Col>
      </Row>
      <Row>  
        
        
         <Col md={6}>
              FIR Document
                                            <Card className="rounded">
                                                <img className="nic" src={process.env.REACT_APP_IMG_URL + family?.cnic_f_img} alt="FIR image" />
                                            </Card>
                                        </Col>

                                         <Col md={6}>
                                         Assesment Image
                                            <Card className="rounded">
                                                <img className="nic" src={process.env.REACT_APP_IMG_URL + family?.cnic_f_img} alt="Assesment" />
                                            </Card>
                                        </Col></Row>
    </div>
  </Col>
</Row>

   
</Row>
         
          
        </PageLayout>
    )
}